// import { useState } from 'react';
import Notifications from './Notifications';
// import { getToken } from '../utils';

function SystemSettingSection() {
  // const [toggle, setToggle] = useState(false);

  // const { token: userToken } = getToken();

  // const handleChange = (e) => {
  //   setToggle(e.target.checked);
  // };
  // console.log(toggle);

  return (
    <section className='px-5 lg:px-32 py-4 md:py-8'>
      <Notifications />

      {/* <div className='border-t-hf flex flex-row justify-between py-6'>
        <div className='flex flex-row gap-4'>
          <svg
            xmlns='http://www.w3.org/2000/svg'
            width='28'
            height='28'
            viewBox='0 0 24 24'
            className='text-s-bk'
          >
            <g fill='currentColor'>
              <path
                fillRule='evenodd'
                d='M2.879 3.844C2 4.687 2 6.044 2 8.76v.96c0 2.715 0 4.073.879 4.916c.878.844 2.293.844 5.121.844h8c2.828 0 4.243 0 5.121-.844c.879-.843.879-2.2.879-4.916v-.96c0-2.715 0-4.073-.879-4.916C20.243 3 18.828 3 16 3H8c-2.828 0-4.243 0-5.121.844Z'
                clipRule='evenodd'
              />
              <path
                d='M18.237 19.596L12.75 17.84v-2.36h-1.5v2.36l-5.487 1.756a.714.714 0 0 0-.474.911a.757.757 0 0 0 .948.455L12 19.118l5.763 1.845a.757.757 0 0 0 .949-.456a.714.714 0 0 0-.475-.91Z'
                opacity='.5'
              />
            </g>
          </svg>
          <div className='flex flex-col '>
            <h3>Display Mode</h3>
            <p className='flex flex-row gap-2 items-center text- text-s-bk'>
              Toggle display mode
            </p>
          </div>
        </div>
        <div className='flex flex-row items-left gap-5'>
          <label className='text-s-bk text-base font-pin relative'>
            Light/Dark Mode
          </label>
          <input
            type='checkbox'
            id='hs-medium-switch'
            className='relative shrink-0 w-[3.25rem] h-7 bg-gray-100 checked:bg-none checked:bg-blue-400 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 ring-1 ring-transparent focus:border-blue-400 focus:ring-blue-400 ring-offset-white focus:outline-none appearance-none dark:bg-s-bk dark:checked:bg-b-mc dark:focus:ring-offset-gray-800 before:inline-block before:w-6 before:h-6 before:bg-white checked:before:bg-blue-200 before:translate-x-0 checked:before:translate-x-full before:shadow before:rounded-full before:transform before:ring-0 before:transition before:ease-in-out before:duration-200 dark:before:bg-p-wh dark:checked:before:bg-blue-200'
            checked={toggle}
            onChange={handleChange}
          />
        </div>
      </div> */}
    </section>
  );
}

export default SystemSettingSection;
